/**
 * @generated SignedSource<<30c733f8355f3c872d29d7654aad6bdd>>
 * @relayHash 6ba935c14b5de5dce37c6e13535100a2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/500.0.0-2025-03-03T10:06:38.949Z/setUserPriceBookNameCookieMutation

import { ConcreteRequest } from 'relay-runtime';
export type SetUserPriceBookNameCookieInput = {
  clientMutationId?: string | null;
  cookieDomain?: string | null;
  countryCode?: string | null;
  zipCode?: string | null;
};
export type setUserPriceBookNameCookieMutation$variables = {
  input: SetUserPriceBookNameCookieInput;
};
export type setUserPriceBookNameCookieMutation$data = {
  readonly setUserPriceBookNameCookie: {
    readonly clientMutationId: string | null;
  } | null;
};
export type setUserPriceBookNameCookieMutation = {
  response: setUserPriceBookNameCookieMutation$data;
  variables: setUserPriceBookNameCookieMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetUserPriceBookNameCookiePayload",
    "kind": "LinkedField",
    "name": "setUserPriceBookNameCookie",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setUserPriceBookNameCookieMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setUserPriceBookNameCookieMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/500.0.0-2025-03-03T10:06:38.949Z/setUserPriceBookNameCookieMutation",
    "metadata": {},
    "name": "setUserPriceBookNameCookieMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "38409ea1d8af209a4c3d5110f23dbfeb";

export default node;
